import React from "react";
import { CircularProgress, WithStyles } from "material-ui";
import withStyles from "material-ui/styles/withStyles";

const styles = {
    root: {
        background: "rgba(255,255,255,.8)",
        width: "100%",
        height: "100%",
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 100,
    },
    circularProgress: {
        width: 100,
        height: 100,
        color: "#92c9f0",
        position: "fixed",
        left: "calc(50% - 50px)",
        top: "calc(50% - 50px)",
    },
} as React.CSSProperties;

interface ISpinnerProps {
    loading: boolean;
}

type ISpinnerPropsWithStyles = ISpinnerProps &
    WithStyles<"root" | "circularProgress">;

const FullPageSpinner: React.SFC<ISpinnerPropsWithStyles> = ({
    classes,
    ...props
}: ISpinnerPropsWithStyles) => {
    const { loading } = props;
    return loading ? (
        <div className={classes.root}>
            <CircularProgress
                className={classes.circularProgress}
                style={{
                    width: 100,
                    height: 100,
                }}
                thickness={2}
            />
        </div>
    ) : (
        <div />
    );
};

export default withStyles(styles)<ISpinnerProps>(FullPageSpinner);



// WEBPACK FOOTER //
// ./src/components/FullPageSpinner/FullPageSpinner.tsx